import React from 'react';

export default function ATSRing({ score, color, label, size = 46 }) {
  const r = size / 2 - 5;
  const circ = 2 * Math.PI * r;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, flexShrink: 0 }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(128,128,128,0.15)" strokeWidth="3.5" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth="3.5"
          strokeDasharray={circ} strokeDashoffset={circ * (1 - score / 100)}
          strokeLinecap="round" style={{ filter: `drop-shadow(0 0 3px ${color}80)` }} />
        <text
          x={size / 2}
          y={size / 2}
          textAnchor="middle"
          dominantBaseline="middle"
          fill={color}
          fontSize={size * 0.22}
          fontWeight="800"
          style={{ transform: 'rotate(90deg)', transformOrigin: 'center', letterSpacing: '-0.5px' }}
        >
          {score}
        </text>
      </svg>
      <span style={{
        fontSize: '7px',
        fontWeight: 800,
        color,
        textTransform: 'uppercase',
        letterSpacing: '0.3px',
        opacity: 0.85,
        whiteSpace: 'nowrap',
      }}>{label}</span>
    </div>
  );
}
